<template>
  <b-container class="container-div">
    <b-card class="login-wrap">
      <h5>静岡県森林クラウド公開システム</h5>
      <div class="version">
        Version: {{ constStore.clientVersion }}
      </div>
      <div class="version">
        Update: {{ constStore.lastUpdate }}
      </div>
      <div class="version">
        {{ constStore.envMode }}
      </div>
      <hr style="width: 16em" />

      <b-form v-on:submit.prevent="login()">
        <div class="form-group mb-3">
          <div class="input-group">
            <div class="input-group-prepend mr-1 mt-2">
              <i class="material-icons text-black-secondary">
                account_circle
              </i>
            </div>
            <input
              type="text"
              v-model="userId"
              class="form-control"
              placeholder="ユーザーID"
              autocomplete="username"
              @focus="onFocus"
              @blur="onBlur"
            />
          </div>
        </div>

        <div class="form-group mb-3">
          <div class="input-group">
            <div class="input-group-prepend mr-1 mt-2">
              <i class="material-icons text-black-secondary"> lock </i>
            </div>
            <input
              type="password"
              v-model="password"
              class="form-control"
              placeholder="パスワード"
              autocomplete="current-password"
            />
          </div>
        </div>

        <div style="margin-top: 10px">
          <b-button
            type="submit"
            class="action-button"
            id="login-production"
            variant="primary"
            style="background: #ff7900"
          >
            ログイン
          </b-button>
        </div>
      </b-form>

      <div v-if="invalid" class="invalid-message">
        ユーザーIDまたはパスワードが<br />正しくありません。
      </div>
    </b-card>
  </b-container>
</template>

<style scoped>
.container-div {
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-top: 2em;
  padding-bottom: 2em;
  height: inherit;
}
.login-wrap {
  width: fit-content;
  margin: auto;
}
.version {
  text-align: center;
  font-size: 12px;
  color: gray;
}
.invalid-message {
  margin-top: 1rem;
  color: red;
  font-size: 16px;
}
.action-button {
  border: 0px;
  font-size: 1rem;
  margin-right: 1px;
  margin-left: 1px;
  padding: 4px 0 3px 0 !important;
  width: 8rem;
  height: 3rem;
}
.material-icons {
  width: 24;
  height: 30;
}
</style>

<script setup>
import { ref, onMounted } from "vue";
import { useRouter } from "vue-router";
import axios from "axios";
import { useConstStore, useManagementAuthStore } from "@/stores";

const router = useRouter();
const constStore = useConstStore();
const managementAuthStore = useManagementAuthStore();

const userId = ref("");
const password = ref("");
const invalid = ref(false);

onMounted(() => {
  if (localStorage.userId) {
    userId.value = localStorage.userId;
  }
});

function onFocus() {
  if (userId.value === "") {
    // userId.value = "AE";
  }
}

function onBlur() {
  if (userId.value === "AE") {
    userId.value = "";
  }
}

function login() {
  localStorage.userId = userId.value;

  let endpoint = constStore.apiEndpoint;
  endpoint += "/v1/management/account/Login/";

  axios
    .post(endpoint, {
      UserId: userId.value,
      Password: password.value
    })
    .then(res => {
      invalid.value = false;
      const token = res.data.token;
      axios.defaults.headers.common["Authorization"] = "Bearer " + token;
      managementAuthStore.storeUserId(userId.value);
      managementAuthStore.storeIsLogin(true);
      managementAuthStore.storeToken(token);

      axios.defaults.headers.common["Authorization"] = "Bearer " + token;

      router.push("/management/Information").catch(failure => {
        console.log(failure);
      });
    })
    .catch(() => {
      password.value = "";
      invalid.value = true;
    });
}
</script>
